import React from 'react'

import { AuditResult } from '@core/entities/audit/AuditResult'
import { TimelineBriefingSessionRoleCard } from './TimelineBriefingSessionRoleCard'

type TimelineBriefingParticipantBlockProps = {
  auditResult: AuditResult
}

const TimelineBriefingParticipantBlock: React.FC<
  TimelineBriefingParticipantBlockProps
> = ({ auditResult }) => {
  const { metadata, appliedToUser, signatureUrl } = auditResult

  return (
    <TimelineBriefingSessionRoleCard
      roleText={metadata?.checklistRoleName ?? metadata?.permitRoleName}
      participants={[
        {
          firstName: appliedToUser?.firstName,
          lastName: appliedToUser?.lastName,
          company: appliedToUser?.company,
          signatureUrl: signatureUrl,
        },
      ]}
      briefingText={metadata?.briefingText}
    />
  )
}

export { TimelineBriefingParticipantBlock }
